import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import useOnClickOutside from 'use-onclickoutside';
import { ButtonWithDropdown } from '@grandvisionhq/elements';
import { PackageQuantityItem } from './PackageQuantityItem.js';
import { QuantityContainer } from './QuantityContainer/QuantityContainer.js';

const getSelectedItem = (items, selectedSize)=>{
    const item = items.find(({ value  })=>value === selectedSize
    );
    return item || items[0] || {
        value: '',
        label: ''
    };
};
const PackageQuantityDropdown = ({ label , title , items , selectedSize , itemView , onChange , 'data-t': dataT = 'package-quantity-dropdown' ,  })=>{
    const [selected, setSelected] = React.useState(()=>getSelectedItem(items, selectedSize)
    );
    const [isOpen1, setIsOpen] = React.useState(false);
    const dropdownRef = React.useRef(null);
    useOnClickOutside(dropdownRef, ()=>setIsOpen(false)
    );
    const buttonLabel = React.useMemo(()=>{
        const Component = itemView || PackageQuantityItem;
        return /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({
            className: "package-quantity-dropdown"
        }, selected));
    }, [
        selected,
        itemView
    ]);
    const handleSelect = React.useCallback((option)=>{
        setSelected(option);
        setIsOpen(false);
        onChange(option);
    }, []);
    const handleClick = React.useCallback(()=>{
        setIsOpen((isOpen)=>!isOpen
        );
    }, []);
    const handleKeyDown = (event)=>{
        if (event.key === 'Escape') {
            event.stopPropagation();
            setIsOpen(false);
        }
    };
    React.useEffect(()=>{
        setSelected(getSelectedItem(items, selectedSize));
    }, [
        setSelected,
        items,
        selectedSize
    ]);
    React.useEffect(()=>{
        const dropdownNode = dropdownRef.current;
        if (isOpen1 && dropdownNode) {
            dropdownNode.addEventListener('keydown', handleKeyDown);
            return ()=>{
                dropdownNode.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [
        isOpen1
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "package-quantity-dropdown",
        ref: dropdownRef,
        "data-t": dataT
    }, Boolean(label) && /*#__PURE__*/ React.createElement("div", {
        className: "package-quantity-dropdown__label"
    }, label), /*#__PURE__*/ React.createElement(ButtonWithDropdown, {
        title: title,
        label: buttonLabel,
        className: "package-quantity-dropdown__button",
        onClick: handleClick,
        isActive: isOpen1,
        isFullWidth: true
    }, /*#__PURE__*/ React.createElement(QuantityContainer, {
        itemView: itemView,
        items: items,
        handleClick: handleSelect,
        selected: selected
    })));
};

export { PackageQuantityDropdown };
//# sourceMappingURL=PackageQuantityDropdown.js.map
